  //upload the docx file to google drive
  export const uploadFileToDrive = (blob,profileName,gapi) => {
    const metadata = {
      name: `${profileName}.docx`,
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    };

    const form = new FormData();
    form.append(
      "metadata",
      new Blob([JSON.stringify(metadata)], { type: "application/json" })
    );
    form.append("file", blob);

    fetch(
      "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
      {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${gapi.auth.getToken().access_token}`,
        }),
        body: form,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("File uploaded successfully", data);
        const fileId = data.id;

        // Construct the file link
        const fileLink = `https://drive.google.com/file/d/${fileId}/view`;

        // Open the link in a new window
        window.open(fileLink, "_blank");
      })
      .catch((error) => console.error("Error uploading file", error));
  };